// extracted by mini-css-extract-plugin
module.exports = {"item":"aed17b9412--item--E9qB_"};